import React, { useEffect, useState } from "react";
import PanelHead from "../../../Panel/PanelHead";
import PanelBody from "../../../Panel/PanelBody";
import { FormTelegramGroup } from "./FormTelegramGrop";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { LinearProgress } from "@mui/material";

export const AddPanelTelegramGrop = () => {
  const [loading, setLoader] = useState(true);
  const [Panels, setPanels] = useState([]);

  // Fetch Panels
  const get_panels = async () => {
    setLoader(true);
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelView,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
      setLoader(false);
    }
  };

  useEffect(() => {
    get_panels();
  }, []);

  return (
    <div>
      <PanelHead title="Add Telegram Group" />
      <PanelBody
        content={
          loading ? (
            <LinearProgress />
          ) : (
            <FormTelegramGroup loading={loading} Panels={Panels} />
          )
        }
      />
    </div>
  );
};
